import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRandom } from "@fortawesome/free-solid-svg-icons";

// add props that can be used to change padding top and bottom
const ShufflePromo = ({ paddingTop = "10px", paddingBottom = "10px" }) => (
  <div className="sideNavSection" style={{ paddingTop: paddingTop, paddingBottom: paddingBottom }}>
    <h3>Not sure what to listen to?</h3>
    <div className="feature shuffle-promo">

      <p className="shuffle-promo-text">

        Re-discover a random track from the DC archives. Hit shuffle and let us know what you find.
      </p>
      <Link
        to="/shuffle"
        className="shuffle-promo-link"
        onClick={() => window.gtag?.("event", "totd_click", { eventLabel: "Tracks Right Nav: Shuffle Promo" })}
      >
        <FontAwesomeIcon icon={faRandom} className="shuffle-promo-icon" /> Hit Shuffle &raquo;
      </Link>
    </div>
  </div>
);

export default ShufflePromo;
